import { render, staticRenderFns } from "./CollectionChain.vue?vue&type=template&id=3307f3d6&"
import script from "./CollectionChain.vue?vue&type=script&lang=js&"
export * from "./CollectionChain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports